// -----------------------------------------------------------------------------
// Script for header forms
// -----------------------------------------------------------------------------

function headerForms() {

  $('.header__contact').on('click', function () {
    $('.header__contact-detail').fadeIn('slow');
  });

  $('.contact-detail__close').on('click', function () {
    $('.header__contact-detail').fadeOut('slow');
  });

  $('.contact-detail__btn-form').on('click', function () {
    $('.header__fast-contact').fadeIn('slow');
    $('.header__contact-detail').fadeOut('slow');
  });

  $('.fast-contact__close').on('click', function () {
    $('.header__fast-contact').fadeOut('slow');
  });

}